
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';
import { APP_CONFIG } from '@/config/app-config';
import { FileType } from '@/models/file-type';
import { PayServiceModel } from '@/models/payservice';
import formatNumber from '@/shared/filters/format-number';

@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class AmountDetailPayService extends Vue {
    @Prop({default: null})
    private payservice!: PayServiceModel;
    private listImages = [] as FileType[];
    private index = null;
    get imgs() {
        return this.listImages.map(x => { return x.src; });
    }
    @Watch('payservice', { immediate: true, deep: true })
    private onComplainChange() {
        if (this.payservice.id > 0) {
            this.listImages = (this.payservice.images ? this.payservice.images.split(';').map((v, i) => {
                    const item = new FileType();
                    item.id = i;
                    item.src = `${APP_CONFIG.settings.firebase_storage}/${APP_CONFIG.settings.firebase_prefix}%2Fpayservice%2F${v}?alt=media`
                    item.fileName = v;
                    return item;
                }) : null) || [];
        }
    }

    showGallery(index: any) {
        this.index = index;
    }
}
